import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["provider"]
  static outlets = ["integrations--new-identity-provider-integration-modal"]

  providerTargetConnected(element) {
    const status = element.dataset.status
    if (status === "pending") return

    if (!this.hasIntegrationsNewIdentityProviderIntegrationModalOutlet) return

    const modal = this.integrationsNewIdentityProviderIntegrationModalOutlet

    if (status === "success") {
      modal.oauthSuccess(element.dataset.provider)
    } else {
      modal.oauthError(element.dataset.provider, element.dataset.message)
    }
  }
}
